
export default {
  name: 'TickerSearchCardSkeleton',
};
